//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import choiceService from './choiceService';

export const getAnnouncements = async () => {
    try {
        const url = `/v1.0/announcement`;
        const res = await choiceService.get(url);
        return (res.data);
    } catch (error) {
        console.error(" error trying to getAnnouncements");
        return (undefined);
    }
}
